import { getName } from '../helpers';
import { getNodeByPath } from '../../../Store/Utils/treeUtils';
import { cloneDeep } from 'lodash';

function enrichObjectWithMixes(docsTree, service) {
  if (!service) {
    return;
  }

  try {
    /*
      find the relevant mixings nodes by the mixins fields path, e.g:

      for { mixes: ["$w.Element", "$w.HiddenCollapsedMixin"] }
      we look for the node (mixin) with the following links: /$w/element, /$w/hiddencollapedmixin

      then we enrich them with their mixings recursively.
    */
    const mixings = service.mixes.map((currentMixin) => {
      const mixinToLink = `/${currentMixin.toLowerCase().replace(/\./g, '/')}`;
      const node = getNodeByPath(docsTree, mixinToLink);
      return enrichObjectWithMixes(docsTree, node.data);
    });

    const memberCollectionToEnrich = [
      'operations',
      'clientEvents',
      'properties',
    ];

    /*
      we run over the mixings (nodes) that we found above, and for each mixin if the member(operation/clientEvent/property)
      doesn't exist in the current service, we clone the mixin member,
      add original field (in order to know what's the original parent of the member) and push it to the current service.
    */
    mixings.forEach((mixinService) => {
      memberCollectionToEnrich.forEach((membersCollection) => {
        if (mixinService[membersCollection]) {
          mixinService[membersCollection].forEach((member) => {
            if (!service[membersCollection]) {
              // if the service doesn't have membersCollection(operations/events/clientEvents) at all, we will leave it empty array.
              service[membersCollection] = [];
            } else if (
              service[membersCollection].every((_) => _.name !== member.name) // prevent member duplicates - add cloned member only if it doesn't exists.
            ) {
              const clonedMember = cloneDeep(member);
              const originalMixedInFrom =
                member.mixedInFrom?.original || mixinService;
              clonedMember.mixedInFrom = {
                name: mixinService.name,
                memberOf: mixinService.memberOf,
                original: {
                  name: originalMixedInFrom.name,
                  memberOf: originalMixedInFrom.memberOf,
                },
              };

              service[membersCollection].push(clonedMember);
            }
          });
        }
      });
    });
  } catch (e) {
    console.error(
      'Failed at enrichObjectWithMixes with the following error: ',
      e,
    );
  }

  return service;
}

export const nodeMixingEnricherVisitor = (docsTree) => (node) => {
  if (node && node.data) {
    try {
      enrichObjectWithMixes(docsTree, node.data);
    } catch (e) {
      console.error(`Failed to enrich ${getName(node.data)} :: `, e);
      throw e;
    }
  }
};
